import React, { Fragment } from 'react';
import SliderList from '../SliderList';
import ShowItems from './ShowItems';
import { TYPE_TV_SHOW } from '../../constants/TypesAndGenreCategory';

class AllShow extends React.Component {

    constructor(props){
        super(props);
        this.state= {
            type : TYPE_TV_SHOW
        }
       ;
      }

    render() {
        return (
            <Fragment>
                <SliderList type={this.state.type} />
                <div>
                    <div className="block-index-movie">
                        <div className="container">
                            <ShowItems type={this.state.type} />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default AllShow;




// WEBPACK FOOTER //
// ./src/containers/TVShow/AllShow.js